@if (dropdownItems) {
  <div ngbDropdown #dropdownMenu="ngbDropdown"
    [autoClose]="true"
    display="dynamic"
    (mouseenter)="onHoverOpen(dropdownMenu)"
    (mouseleave)="onHoverClose(dropdownMenu)">
    @if (!isVisibleFunction || isVisibleFunction({ dataItem: dataItem })) {
      <button
        [ngClass]="computedClass"
        [disabled]="isDisabled || isLoading"
        (mouseenter)="onButtonHover()"
        type="buttonType"
        id="{{buttonId}}"
        [ngbTooltip]="tooltipText | translate"
        [placement]="tooltipPlacement"
        [attr.title]="isMessageTranslated ? (message | translate:messageTranslationParameters) : message"
        ngbDropdownToggle>
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    <div
      ngbDropdownMenu (click)="dropdownMenu.close()"
      [attr.aria-labelledby]="'dropdown ' + message"
      [ngClass]="dropdownClasses">
      <ng-content select="[dropdownContent]"></ng-content>
      @for (item of dropdownItems; track item; let dropdownItemIndex = $index) {
        <div
          class="p-1"
          [ngClass]="{'active' : item.isActive}">
          @if (dropdownItemIndex > 0 && item.groupId !== dropdownItems[dropdownItemIndex - 1].groupId) {
            <div role="separator"
              class="divider"
            ></div>
          }
          @if (!item.isVisibleFunction || item.isVisibleFunction({ dataItem: dataItem, dropdownItemIndex: dropdownItemIndex })) {
            <ng-container
            [ngTemplateOutlet]="item.route ? hasRoute : item.externalUrl ? hasExternalUrl : noRouteOrExternalUrl"></ng-container>
          }
          <ng-template #hasRoute>
            <a [routerLink]="item.route"
              ngbDropdownItem
              class="btn btn-link button__dropdown-item"
              [ngClass]="{'button__dropdown-item--active' : item.isActive}"
              [ngbTooltip]="item.message | translate:item.messageTranslationParameters"
              [placement]="tooltipPlacement">
              <ng-container *ngTemplateOutlet="dropDownInnerContent; context: {item}"></ng-container>
            </a>
          </ng-template>
          <ng-template #hasExternalUrl>
            <a [href]="item.externalUrl"
              ngbDropdownItem
              class="btn btn-link button__dropdown-item"
              [ngClass]="{'button__dropdown-item--active' : item.isActive}"
              [attr.target]="item.openInSeparateTab ? '_blank' : null"
              [attr.rel]="item.openInSeparateTab ? 'noopener noreferrer' : null"
              [ngbTooltip]="item.message | translate:item.messageTranslationParameters"
              [placement]="tooltipPlacement">
              <ng-container *ngTemplateOutlet="dropDownInnerContent; context: {item}"></ng-container>
            </a>
          </ng-template>
          <ng-template #noRouteOrExternalUrl>
            <button (click)="onDropdownItemClick(dropdownItemIndex)"
              ngbDropdownItem
              class="btn btn-link button__dropdown-item"
              [ngClass]="{'button__dropdown-item--active' : item.isActive}"
              [ngbTooltip]="item.message | translate:item.messageTranslationParameters"
              [placement]="tooltipPlacement">
              <ng-container *ngTemplateOutlet="dropDownInnerContent; context: {item}"></ng-container>
            </button>
          </ng-template>
        </div>
      }
    </div>
  </div>
} @else {
  <button [ngClass]="computedClass"
    [disabled]="isDisabled || isLoading"
    (click)="onButtonClick()"
    (mouseenter)="onButtonHover()"
    type="buttonType"
    id="{{buttonId}}"
    [ngbTooltip]="showTooltip ? (isMessageTranslated ? ((tooltipText || message) | translate:messageTranslationParameters) : (tooltipText || message)) : null"
    [placement]="tooltipPlacement">
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
}

<ng-template #dropDownInnerContent let-item="item">
  @if (item.iconImageUrl) {
    <sb-icon-svg-img
      [imgUrl]="item.iconImageUrl"
      class="dropdown-icon">
    </sb-icon-svg-img>
  }
  @if (item.iconName) {
    <sb-icon
      name="{{item.iconName}}"
      [class]="item.iconClasses"
      class="dropdown-icon"
    [overrideStyle]="item.iconStyle"></sb-icon>
  }
  @if (iClass) {
    <i
      class="mr-1"
    [ngClass]="iClass"></i>
  }
  @if (item.imgUrl) {
    <img
      [src]="item.imgUrl"/>
  }
  @if (item.message) {
    <span
      [ngClass]="{'ml-2' : item.iconName || item.iconImageUrl}">
      <span [ngClass]="{'hidden-xs' : item.xsIconOnly || item.messageXs}">{{item.message | translate:item.messageTranslationParameters}}</span>
      @if (item.messageXs) {
        <span class="hidden-sm hidden-md hidden-lg">{{item.messageXs | translate:item.messageTranslationParameters}}</span>
      }
    </span>
  }
</ng-template>


<ng-template #buttonContent>
  @if (!isLoading) {
    <span
      [ngClass]="{'align-center justify-center' : !note}">
      @if (iconName) {
        <sb-icon
          name="{{iconName}}"
          [class]="iconClasses"
          [overrideStyle]="iconStyle"
        [size]="iconSize"></sb-icon>
      }
      @if (iClass) {
        <i
          class="mr-1"
        [ngClass]="iClass"></i>
      }
      @if (imgUrl) {
        <img
          [src]="imgUrl"/>
      }
      @if (message) {
        <span
          [ngClass]="{'ml-2' : iconName}"
          [style.font-size]="fontSizeStyle">
          <span [ngClass]="{'hidden-xs' : xsIconOnly || messageXs}">{{isMessageTranslated ? (message | translate:messageTranslationParameters) : message}}</span>
          @if (messageXs) {
            <span class="hidden-sm hidden-md hidden-lg">{{isMessageTranslated ? (messageXs | translate:messageTranslationParameters) : messageXs}}</span>
          }
        </span>
      }
      @if (note) {
        <div
          class="text-muted mt-1"
        [innerHTML]="note"></div>
      }
    </span>
  }
  @if (isLoading) {
    <sb-icon
    name="loading"></sb-icon>
  }
  <ng-content></ng-content>
</ng-template>
